import { CursoComplementar } from '../../cursos-complementares.types';
import {
  CursoComplementarApiResponse,
  Result,
} from '../../services/consultar-cursos-complementares/consultar-cursos-complementares.types';

export const cursosComplementaresMapper = (apiResult: Result): CursoComplementar[] =>
  apiResult.map((item: CursoComplementarApiResponse) => ({
    codigo: item.codigo,
    titulo: item.titulo,
    url: item.url,
    resumo: item.resumo,
    cargaHorariaEmMinutos: item.cargaHorariaEmMinutos,
  }));
